import { render, staticRenderFns } from "./SandboxCardInline.vue?vue&type=template&id=a877d218&scoped=true&"
import script from "./SandboxCardInline.vue?vue&type=script&lang=js&"
export * from "./SandboxCardInline.vue?vue&type=script&lang=js&"
import style0 from "./SandboxCardInline.vue?vue&type=style&index=0&id=a877d218&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a877d218",
  null
  
)

export default component.exports